import { createFileRoute } from '@tanstack/react-router'
import { Facebook } from '@/components/settings-route/multi-channel/facebook/index.jsx'

export const Route = createFileRoute('/_auth/settings/multi-channels/facebook')(
  {
    component: Facebook,
  },
)
